export const links = {
    '/': 'Estado de cuenta',
    '/payments': 'Generar pagos',
    '/payment': 'Solicitar Cobros',
    '/payments-tray': 'Bandeja de pagos',
    '/charges-tray': 'Bandeja de cobros',
    '/checkbook-pays': 'Cheques recibidos',
    '/checkbook-charge': 'Cheques emitidos',
    '/taxes': 'Pagar servicios',
    '/internal-transfers': 'Transferencias Internas',
    '/user-register': 'Registrar nuevo usuario',
    '/password-change': 'Cambiar password',
}